import React, { useEffect } from "react";
import { useState } from "react";
import { ModalDialog } from "./ModalDialog";

function ItemsSelector({ items, enable, onSave, fields, values, name, error, col = 6 }) {
  const [selectedElements, setSelectedElements] = useState(values);

  const [modalIsOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const handleShow = () => setIsOpen(true);

  useEffect(() => setSelectedElements(values), [values]);

  const handleSave = () => {
    onSave(selectedElements);
    handleClose();
  };

  const onItemChange = (i) => {
    const index = selectedElements.findIndex((item) => item.id === i.id);
    let _selectedElements = [...selectedElements];
    if (index !== -1)
      _selectedElements = selectedElements.reduce((a, e, i) => {
        if (i !== index) a.push(e);
        return a;
      }, []);
    else _selectedElements.push(i);
    setSelectedElements([..._selectedElements]);
  };

  const onSelectAll = (selectAll) => {
    if (selectAll) setSelectedElements([...items]);
    else setSelectedElements([]);
  };

  return (
    <div className={`col-md-${col}`}>
      <button
        type="button"
        onClick={handleShow}
        className={"btn w-100 " + (error ? "btn-danger" : "btn-outline-secondary")}
        disabled={!enable}
      >
        {name}
      </button>
      <ModalDialog
        title={name}
        shouldShow={modalIsOpen}
        onClose={handleClose}
        items={items}
        selectedItems={selectedElements}
        fields={fields}
        onItemChange={onItemChange}
        onSave={handleSave}
        onSelectAll={onSelectAll}
      />
    </div>
  );
}

export default ItemsSelector;
